
        export default {
          src: "/assets/responsive/LOGO-b5c484f6-responsive-icon.png",
          sources: [{ type: "image/webp", srcSet: `/assets/responsive/LOGO-b5c484f6-responsive-icon-40.webp 40w, /assets/responsive/LOGO-b5c484f6-responsive-icon-80.webp 80w` }],
          width: 512,
          height: 512,
        };
      